// gimme: conversations-inbox-ui 06/10/2020 24a2e66917cc934433dd111db7e06fd02943ca6a
'use es6';

import pluck from 'transmute/pluck';
import { createSelector } from 'reselect';
import { getTypingIndicators } from './getTypingIndicators';
export const getTypingIndicatorMessagesList = createSelector([getTypingIndicators], typingIndicators => pluck('message', typingIndicators).toList());